import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  styles: [`
    table {
      width: 100%;
    }
  `]
})
export class TableComponent implements OnInit, OnChanges {
  displayedColumns: string[] = [];
  @Input() list: any[] = [];
  @Output() clicked = new EventEmitter<any>();
  @Input() translation: any = {};
  constructor(public settings: AppSettingsService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('translation: ', this.translation);
    console.log('log: ', this.list, changes.list);
    if (this.list.length) {
      let counter = 1;
      this.list.forEach(object => {
        object.position = counter++;
      });
      this.displayedColumns = ['position'];
      for (const key in this.list[0]) {
        if (this.list[0].hasOwnProperty(key) && key !== 'position') {
          this.displayedColumns.push(key);
        }
      }
      console.log('display', this.displayedColumns);
    }
  }

  clickedRow(row: any) {
    console.log(row);
    this.clicked.emit(row);
  }
}
